// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./SnackbarStyles";
// @otg-one/ui_components/components
import { Typography, Button } from '../index';
// @otg-one/ui_components/icons
// import { OntegoOneLogoWhiteAlt, Settings, Alert } from '../../icons';
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Material UI Core
import Grid from '@mui/material/Grid';
import Slide from '@mui/material/Slide';
export const Snackbar = (props) => {
    const classes = useStyles(props);
    const { id, show, onClick, icon, children, showButton, textButtonLabel, animationDuration, backgroundColor } = props;
    return (React.createElement(Slide, { direction: "up", in: show, mountOnEnter: true, unmountOnExit: true },
        React.createElement("div", { className: classes.snackbarWrapper, style: { backgroundColor: backgroundColor }, id: id },
            React.createElement("div", { className: classes.meter, style: { animationDuration: `${animationDuration}ms`, WebkitAnimationDuration: `${animationDuration}ms` } }),
            React.createElement("div", { className: classes.snackbarContainer },
                React.createElement(Grid, { container: true, style: { flexGrow: 1 }, spacing: 2 },
                    React.createElement(Grid, { item: true, md: 2 },
                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', float: "left" } },
                            React.createElement("div", { className: classes.snackbarIconContainer }, icon))),
                    React.createElement(Grid, { item: true, md: 8 },
                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', marginTop: 12 } },
                            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[0] }, children))),
                    React.createElement(Grid, { item: true, md: 2 },
                        React.createElement("div", { style: { float: "right" } }, showButton && (React.createElement(Button, { color: "white", onClick: onClick }, textButtonLabel)))))))));
};
Snackbar.defaultProps = {
    showButton: false,
    textButtonLabel: "Close",
    animationDuration: 1000,
    backgroundColor: Color.primary[400],
};
export default React.memo(Snackbar);
